module.exports = __webpack_public_path__ + "img/tpc-33.e2e07f8c.jpg";